import { AG_GRID_LOCALE_NL } from '@ag-grid-community/locale';

// Take the ag-grid locales and override with our own translations
/** Default BAR AG grid locale. */
export const BAR_AG_GRID_LOCALE = {
    // take default translations
    ...AG_GRID_LOCALE_NL,
    // recent overschreden #348146
    pageSizeSelectorLabel: 'Paginagrootte:',
    chooseColumns: 'Kolommen kiezen',
    columnChooser: 'Kolommen kiezen',
    // override default translations
    selectAll: '(Alles selecteren)',
    selectAllSearchResults: '(Selecteer alle zoekresultaten)',
    searchOoo: 'Zoeken...',
    blanks: '(Leeg)',
    noMatches: 'Geen overeenkomsten',

    // Number Filter & Text Filter
    filterOoo: 'Filteren...',
    equals: 'Gelijk',
    notEqual: 'Verschillend van',
    empty: 'Kiezen',

    // Number Filter
    lessThan: 'Kleiner dan',
    greaterThan: 'Groter dan',
    lessThanOrEqual: 'Kleiner of gelijk aan',
    greaterThanOrEqual: 'Groter of gelijk aan',
    inRange: 'Binnen bereik',
    inRangeStart: 'tot',
    inRangeEnd: 'vanaf',

    // Text Filter
    contains: 'Bevat',
    notContains: 'Bevat niet',
    startsWith: 'Begint met',
    endsWith: 'Eindigt met',
    blank: 'Leeg',
    notBlank: 'Niet leeg',

    // Date Filter
    dateFormatOoo: 'yyyy-mm-dd',

    // Filter Conditions
    andCondition: 'EN',
    orCondition: 'OF',

    // Filter Buttons
    applyFilter: 'Toepassen...',
    resetFilter: 'Reset',
    clearFilter: 'Leegmaken',
    cancelFilter: 'Annuleren',

    // Filter Titles
    textFilter: 'Tekst filter',
    numberFilter: 'Nummer filter',
    dateFilter: 'Datum filter',
    setFilter: 'Filter instellen',

    // Side Bar
    columns: 'Kolommen',
    filters: 'Filters',

    // columns tool panel
    pivotMode: 'Pivoteer-modus',
    groups: 'Groepen',
    rowGroupColumnsEmptyMessage: 'Sleep hier kolommen om te groeperen',
    values: 'Waarden',
    valueColumnsEmptyMessage: 'Sleep hier kolommen om samen te voegen',
    pivots: 'Gepivoteerde kolommen',
    pivotColumnsEmptyMessage: 'Sleep hier kolommen om te pivoteren',

    // Header of the Default Group Column
    group: 'Groep',

    // Other
    loadingOoo: 'Laden...',
    noRowsToShow: 'Er zijn geen gegevens',
    noMatchingRows: 'Er zijn geen gegevens voor deze filtering',
    enabled: 'Ingeschakeld',

    // Menu
    pinColumn: 'Kolom vastpinnen',
    pinLeft: 'Links vastpinnen',
    pinRight: 'Rechts vastpinnen',
    noPin: 'Niet vastpinnen',
    valueAggregation: 'Gezamelijke waarde',
    autosizeThiscolumn: 'Grootte van deze kolom automatisch aanpassen',
    autosizeAllColumns: 'Grootte van alle kolommen automatisch aanpassen',
    groupBy: 'Groeperen op',
    ungroupBy: 'Degroeperen',
    resetColumns: 'Kolommen resetten',
    expandAll: 'Alles uitklappen',
    collapseAll: 'Alles inklappen',
    copy: 'Kopiëren',
    ctrlC: 'Ctrl+C',
    ctrlX: 'Ctrl+X',
    copyWithHeaders: 'Kopiëren met hoofding',
    copyWithGroupHeaders: 'Kopiëren met groep hoofding',
    paste: 'Plakken',
    cut: 'Knippen',
    ctrlV: 'Ctrl+V',
    export: 'Exporteren',
    csvExport: 'Exporteren naar csv',
    excelExport: 'Exporteren naar excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Som',
    min: 'Min.',
    max: 'Max.',
    none: 'Geen',
    count: 'Aantal',
    avg: 'Gemiddelde',
    filteredRows: 'Gefilterd',
    selectedRows: 'Geselecteerd',
    totalRows: 'Totaal aantal',
    totalAndFilteredRows: 'Rijen',
    more: 'meer',
    to: 'tot',
    of: 'van',
    page: 'Pagina',
    nextPage: 'Volgende pagina',
    lastPage: 'Laatste pagina',
    firstPage: 'Eerste pagina',
    previousPage: 'Vorige pagina',

    // Pivoting
    pivotColumnGroupTotals: 'Totaal',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Pivot Chart & Pivot Mode',
    pivotChart: 'Pivot Chart',
    chartRange: 'Chart Range',

    columnChart: 'Column',
    groupedColumn: 'Grouped',
    stackedColumn: 'Stacked',
    normalizedColumn: '100% Stacked',

    barChart: 'Bar',
    groupedBar: 'Grouped',
    stackedBar: 'Stacked',
    normalizedBar: '100% Stacked',

    pieChart: 'Pie',
    pie: 'Pie',
    doughnut: 'Doughnut',

    line: 'Line',

    xyChart: 'X Y (Scatter)',
    scatter: 'Scatter',
    bubble: 'Bubble',

    areaChart: 'Area',
    area: 'Area',
    stackedArea: 'Stacked',
    normalizedArea: '100% Stacked',

    histogramChart: 'Histogram',

    // Charts
    pivotChartTitle: 'Pivot Chart',
    rangeChartTitle: 'Range Chart',
    settings: 'Settings',
    data: 'Data',
    format: 'Format',
    categories: 'Categories',
    defaultCategory: '(None)',
    series: 'Series',
    xyValues: 'X Y Values',
    paired: 'Paired Mode',
    axis: 'Axis',
    navigator: 'Navigator',
    color: 'Color',
    thickness: 'Thickness',
    xType: 'X Type',
    automatic: 'Automatic',
    category: 'Category',
    number: 'Number',
    time: 'Time',
    xRotation: 'X Rotation',
    yRotation: 'Y Rotation',
    ticks: 'Ticks',
    width: 'Width',
    height: 'Height',
    length: 'Length',
    padding: 'Padding',
    spacing: 'Spacing',
    chart: 'Chart',
    title: 'Title',
    titlePlaceholder: 'Chart title - double click to edit',
    background: 'Background',
    font: 'Font',
    top: 'Top',
    right: 'Right',
    bottom: 'Bottom',
    left: 'Left',
    labels: 'Labels',
    size: 'Size',
    minSize: 'Minimum Size',
    maxSize: 'Maximum Size',
    legend: 'Legend',
    position: 'Position',
    markerSize: 'Marker Size',
    markerStroke: 'Marker Stroke',
    markerPadding: 'Marker Padding',
    itemSpacing: 'Item Spacing',
    itemPaddingX: 'Item Padding X',
    itemPaddingY: 'Item Padding Y',
    layoutHorizontalSpacing: 'Horizontal Spacing',
    layoutVerticalSpacing: 'Vertical Spacing',
    strokeWidth: 'Stroke Width',
    offset: 'Offset',
    offsets: 'Offsets',
    tooltips: 'Tooltips',
    callout: 'Callout',
    markers: 'Markers',
    shadow: 'Shadow',
    blur: 'Blur',
    xOffset: 'X Offset',
    yOffset: 'Y Offset',
    lineWidth: 'Line Width',
    normal: 'Normal',
    bold: 'Bold',
    italic: 'Italic',
    boldItalic: 'Bold Italic',
    predefined: 'Predefined',
    fillOpacity: 'Fill Opacity',
    strokeOpacity: 'Line Opacity',
    histogramBinCount: 'Bin count',
    columnGroup: 'Column',
    barGroup: 'Bar',
    pieGroup: 'Pie',
    lineGroup: 'Line',
    scatterGroup: 'X Y (Scatter)',
    areaGroup: 'Area',
    histogramGroup: 'Histogram',
    groupedColumnTooltip: 'Grouped',
    stackedColumnTooltip: 'Stacked',
    normalizedColumnTooltip: '100% Stacked',
    groupedBarTooltip: 'Grouped',
    stackedBarTooltip: 'Stacked',
    normalizedBarTooltip: '100% Stacked',
    pieTooltip: 'Pie',
    doughnutTooltip: 'Doughnut',
    lineTooltip: 'Line',
    groupedAreaTooltip: 'Area',
    stackedAreaTooltip: 'Stacked',
    normalizedAreaTooltip: '100% Stacked',
    scatterTooltip: 'Scatter',
    bubbleTooltip: 'Bubble',
    histogramTooltip: 'Histogram',
    noDataToChart: 'No data available to be charted.',
    pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Linked to Grid',
    chartUnlinkToolbarTooltip: 'Unlinked from Grid',
    chartDownloadToolbarTooltip: 'Download Chart',

    // ARIA
    ariaAdvancedFilterBuilderItem: '${variable}. Niveau ${variable}. Druk op ENTER om te bewerken.',
    ariaAdvancedFilterBuilderItemValidation: '${variable}. Niveau ${variable}. ${variable} Druk op ENTER om te bewerken.',
    ariaAdvancedFilterBuilderList: 'Geavanceerde Filter Builder Lijst',
    ariaAdvancedFilterBuilderFilterItem: 'Filter Voorwaarde',
    ariaAdvancedFilterBuilderGroupItem: 'Filter Groep',
    ariaAdvancedFilterBuilderColumn: 'Kolom',
    ariaAdvancedFilterBuilderOption: 'Optie',
    ariaAdvancedFilterBuilderValueP: 'Waarde',
    ariaAdvancedFilterBuilderJoinOperator: 'Koppelingsoperator',
    ariaAdvancedFilterInput: 'Geavanceerde Filter Invoer',
    ariaHidden: 'verborgen',
    ariaVisible: 'zichtbaar',
    ariaChecked: 'aangevinkt',
    ariaUnchecked: 'uitgevinkt',
    ariaIndeterminate: 'onbepaald',
    ariaColumnSelectAll: 'Toggle selecteer alle kolommen',
    ariaInputEditor: 'Input editor',
    ariaDateFilterInput: 'Datum filter input',
    ariaFilterInput: 'Filter input',
    ariaFilterColumnsInput: 'Filter kolommen input',
    ariaFilterValue: 'Filter waarde',
    ariaFilterFromValue: 'Filter vanaf waarde',
    ariaFilterToValue: 'Filter tot waarde',
    ariaFilteringOperator: 'Filter operator',
    ariaColumnToggleVisibility: 'kolom toggle zichtbaarheid',
    ariaColumnGroupToggleVisibility: 'Groepkolom toggle zichtbaarheid',
    ariaRowSelect: 'Druk SPATIE om deze rij te selecteren',
    ariaRowDeselect: 'Druk SPATIE om deze rij te deselecteren',
    ariaRowToggleSelection: 'Druk SPATIE om de rijselectie te togglen',
    ariaRowSelectAll: 'Druk SPATIE om alle-rijselectie te togglen',
    ariaSearch: 'Zoeken',
    ariaSearchFilterValues: 'Zoek filter waarden',
    ariaColumn: 'Kolom',
    ariaColumnGroup: 'Kolom Groep',
    ariaColumnList: 'Kolom Lijst',
    ariaColumnFiltered: 'Kolom Gefilterd',
    ariaDefaultListName: 'Lijst',
    ariaFilterList: 'Filter Lijst',
    ariaFilterMenuOpen: 'Open Filter Menu',
    ariaMenuColumn: 'Druk op ALT OMHOOG om kolom menu te openen',
    ariaFilterColumn: 'Druk op CTRL ENTER om filter te openen',
    ariaRowSelectionDisabled: 'Rijselectie is uitgeschakeld voor deze rij',
    ariaSortableColumn: 'Druk op ENTER om te sorteren',
    ariaToggleVisibility: 'Druk op SPATIE om zichtbaarheid te wisselen',
    ariaToggleCellValue: 'Druk op SPATIE om celwaarde te wisselen',
    ariaPageSizeSelectorLabel: 'Paginagrootte',
    ariaChartMenuClose: 'Sluit Grafiek Bewerk Menu',
    ariaSkeletonCellLoadingFailed: 'Rij laden mislukt',
    ariaSkeletonCellLoading: 'Rijgegevens worden geladen',

    // ARIA Labels voor Dropzones
    ariaRowGroupDropZonePanelLabel: 'Rijgroepen',
    ariaValuesDropZonePanelLabel: 'Waarden',
    ariaPivotDropZonePanelLabel: 'Kolomlabels',
    ariaDropZoneColumnComponentDescription: 'Druk op DELETE om te verwijderen',
    ariaDropZoneColumnValueItemDescription: 'Druk op ENTER om het aggregatietype te wijzigen',
    ariaDropZoneColumnGroupItemDescription: 'Druk op ENTER om te sorteren',
    // gebruikt voor aggregaat dropzone, formaat: {aggregatie}{ariaDropZoneColumnComponentAggFuncSeparator}{kolomnaam}
    ariaDropZoneColumnComponentAggFuncSeparator: ' van ',
    ariaDropZoneColumnComponentSortAscending: 'oplopend',
    ariaDropZoneColumnComponentSortDescending: 'aflopend',

    // ARIA Labels voor Dialogen
    ariaLabelColumnMenu: 'Kolommenu',
    ariaLabelColumnFilter: 'Kolomfilter',
    ariaLabelCellEditor: 'Celleditor',
    ariaLabelDialog: 'Dialoog',
    ariaLabelSelectField: 'Selecteer veld',
    ariaLabelRichSelectField: 'Uitgebreid selecteren veld',
    ariaLabelTooltip: 'Tooltip',
    ariaLabelContextMenu: 'Contextmenu',
    ariaLabelSubMenu: 'Submenu',
    ariaLabelAggregationFunction: 'Aggregatiefunctie',
    ariaLabelAdvancedFilterAutocomplete: 'Geavanceerde filter autocompletie',
    ariaLabelAdvancedFilterBuilderAddField: 'Geavanceerde filterbouwer veld toevoegen',
    ariaLabelAdvancedFilterBuilderColumnSelectField: 'Geavanceerde filterbouwer kolom selecteren veld',
    ariaLabelAdvancedFilterBuilderOptionSelectField: 'Geavanceerde filterbouwer optie selecteren veld',
    ariaLabelAdvancedFilterBuilderJoinSelectField: 'Geavanceerde filterbouwer join operator selecteren veld',

    // ARIA Labels voor de Zijbalk
    ariaColumnPanelList: 'Kolomlijst',
    ariaFilterPanelList: 'Filterlijst',

    // Number Format (Status Bar, Pagination Panel)
    thousandSeparator: '.',
    decimalSeparator: ',',

    // Advanced filters
    advancedFilterContains: 'bevat',
    advancedFilterNotContains: 'bevat niet',
    advancedFilterTextEquals: 'is gelijk aan',
    advancedFilterTextNotEqual: 'is niet gelijk aan',
    advancedFilterStartsWith: 'begint met',
    advancedFilterEndsWith: 'eindigt met',
    advancedFilterBlank: 'is leeg',
    advancedFilterNotBlank: 'is niet leeg',
    advancedFilterEquals: '=',
    advancedFilterNotEqual: '!=',
    advancedFilterGreaterThan: '>',
    advancedFilterGreaterThanOrEqual: '>=',
    advancedFilterLessThan: '<',
    advancedFilterLessThanOrEqual: '<=',
    advancedFilterTrue: 'is waar',
    advancedFilterFalse: 'is onwaar',
    advancedFilterAnd: 'EN',
    advancedFilterOr: 'OF',
    advancedFilterApply: 'Toepassen',
    advancedFilterBuilder: 'Bouwer',
    advancedFilterValidationMissingColumn: 'Kolom ontbreekt',
    advancedFilterValidationMissingOption: 'Optie ontbreekt',
    advancedFilterValidationMissingValue: 'Waarde ontbreekt',
    advancedFilterValidationInvalidColumn: 'Kolom niet gevonden',
    advancedFilterValidationInvalidOption: 'Optie niet gevonden',
    advancedFilterValidationMissingQuote: 'Waarde mist een eindquote',
    advancedFilterValidationNotANumber: 'Waarde is geen nummer',
    advancedFilterValidationInvalidDate: 'Waarde is geen geldige datum',
    advancedFilterValidationMissingCondition: 'Voorwaarde ontbreekt',
    advancedFilterValidationJoinOperatorMismatch: 'Koppeloperatoren binnen een voorwaarde moeten hetzelfde zijn',
    advancedFilterValidationInvalidJoinOperator: 'Koppeloperator niet gevonden',
    advancedFilterValidationMissingEndBracket: 'Ontbrekende eindhaak',
    advancedFilterValidationExtraEndBracket: 'Te veel eindhaken',
    advancedFilterValidationMessage: 'Uitdrukking heeft een fout. ${variable} - ${variable}.',
    advancedFilterValidationMessageAtEnd: 'Uitdrukking heeft een fout. ${variable} aan het einde van de uitdrukking.',
    advancedFilterBuilderTitle: 'Geavanceerde Filter',
    advancedFilterBuilderApply: 'Toepassen',
    advancedFilterBuilderCancel: 'Annuleren',
    advancedFilterBuilderAddButtonTooltip: 'Filter of Groep toevoegen',
    advancedFilterBuilderRemoveButtonTooltip: 'Verwijderen',
    advancedFilterBuilderMoveUpButtonTooltip: 'Omhoog verplaatsen',
    advancedFilterBuilderMoveDownButtonTooltip: 'Omlaag verplaatsen',
    advancedFilterBuilderAddJoin: 'Groep toevoegen',
    advancedFilterBuilderAddCondition: 'Filter toevoegen',
    advancedFilterBuilderSelectColumn: 'Selecteer een kolom',
    advancedFilterBuilderSelectOption: 'Selecteer een optie',
    advancedFilterBuilderEnterValue: 'Voer een waarde in...',
    advancedFilterBuilderValidationAlreadyApplied: 'Huidige filter al toegepast.',
    advancedFilterBuilderValidationIncomplete: 'Niet alle voorwaarden zijn compleet.',
    advancedFilterBuilderValidationSelectColumn: 'Moet een kolom selecteren.',
    advancedFilterBuilderValidationSelectOption: 'Moet een optie selecteren.',
    advancedFilterBuilderValidationEnterValue: 'Moet een waarde invoeren.'
};
